import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'
import { Usuario } from './usuarios'

const UserSchema = zod.UsuarioSchema.extend({
    Funcionario: z.array(zod.FuncionarioSchema).optional(),
})

export type FuncionarioUsuario = z.infer<typeof zod.FuncionarioSchema>
export type User = z.infer<typeof UserSchema>

const TokenSchema = z.object({
    token: z.string(),
    refreshToken: z.string(),
    user: UserSchema,
})

export type Token = z.infer<typeof TokenSchema>

const CpfSchema = z
    .string()
    .transform(cpf => cpf.replace(/\D/g, ''))
    .refine(cpf => cpf.length === 11, 'CPF deve ter 11 dígitos')

const LoginEmailOrCpfSchema = CpfSchema.or(
    z.string().trim().email().toLowerCase(),
)

export const LoginSchema = z.object({
    email: LoginEmailOrCpfSchema,
    password: z.string().trim().min(1),
    rememberMe: z.boolean().optional(),
})

export type Login = z.infer<typeof LoginSchema>

type AlterarSenha =
    | {
          senhaAnterior: string
          confirmarNovaSenha: string
      }
    | {
          senha: string
          hash: string
      }

interface HistoricoLogin {
    origem: string
    dataLogin: Date
    platform: string
    navegador: string
    ref: string
    ip: string
}

const service = new ApiService<unknown, void>('auth')
export const auth = Object.assign(service, {
    recuperar: new ApiService<{ email: string }, any>('auth/recuperar-senha'),
    alterar: new ApiService<AlterarSenha, Usuario>('auth/alterar-senha'),
    login: new ApiService<Login, Token>('auth/session'),
    historico: new ApiService<never, HistoricoLogin>('auth/historico'),
})
